<template>
  <div ref="transportPanel" class="transport"></div>
</template>
<script>
import * as echarts from "echarts";
import { debounce } from "lodash";
export default {
  name: "TransportPanel",
  props: {
    seriesData: {
      type: Array,
      required: true,
    },
  },
  watch: {
    seriesData: {
      immediate: true,
      handler(newVal) {
        for (let i = 0; i < newVal.length; i++) {
          const element = newVal[i];
          this.option.series[0].data[i] = {
            value: element.value,
            name: element.name,
          };
        }
        this.chartInstance?.setOption(this.option);
      },
    },
    // 监听 option 变化并更新图表
    option: {
      handler(newOption) {
        this.chartInstance?.setOption(newOption);
      },
      deep: true,
    },
  },
  data() {
    return {
      myChart: null,
      chartInstance: null,
      option: {
        color: [
          "#FFCC47",
          "#00F3FD",
          "#CE11DF",
          "#ED1A3A",
          "#17DE53",
          "#58976B",
          "#4B6AD9",
          "#795AA8",
          "#69A436",
        ],
        tooltip: {
          trigger: "item",
        },
        legend: {
          top: "center",
          right: "10%",
          orient: "vertical",
          itemGap: 12,
          textStyle: {
            color: "#ffffff",
          },
        },
        series: [
          {
            name: this.$t("screen.transportEarnings"),
            type: "pie",
            center: ["30%", "50%"],
            radius: ["47%", "75%"],
            avoidLabelOverlap: false,
            clockwise: false,
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              scaleSize: 15,
              label: {
                formatter: "{b}\n{d}%",
                show: true,
                fontSize: 20,
                color: "#ffffff",
              },
            },
            labelLine: {
              show: false,
            },
            data: [],
          },
        ],
      },
    };
  },
  mounted() {
    this.initChart();
    window.addEventListener("resize", this.resizeChart);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizeChart);
    this.chartInstance?.dispose();
  },
  methods: {
    initChart() {
      for (let i = 0; i < this.seriesData.length; i++) {
        const element = this.seriesData[i];
        this.option.series[0].data[i] = {
          value: element.value,
          name: element.name,
        };
      }
      if (!this.$refs.transportPanel) return;
      this.chartInstance = echarts.init(this.$refs.transportPanel);
      this.chartInstance.setOption(this.option);
      this.$emit("ready");
    },
    resizeChart: debounce(function () {
      this.chartInstance?.resize();
    }, 200),
  },
};
</script>
<style lang="scss" scoped>
@import "./style.scss";
</style>